import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import type { RouteDef } from "./RouteDef";

export const RequestQueueRoutes = {
  REQUEST_QUEUE: {
    paths: { [LanguageEnum.CS]: "/fronta-pozadavku", [LanguageEnum.EN]: "/request-queue" },
    aliases: ["/fronta-požadavků"],
  },
  REQUEST_QUEUE_MINE: {
    paths: {
      [LanguageEnum.CS]: "/fronta-pozadavku/moje",
      [LanguageEnum.EN]: "/request-queue/mine",
    },
    aliases: ["/fronta-požadavků/moje"],
  },
  REQUEST_QUEUE_HISTORY: {
    paths: {
      [LanguageEnum.CS]: "/fronta-pozadavku/moje/historie",
      [LanguageEnum.EN]: "/request-queue/mine/history",
    },
    aliases: ["/fronta-požadavků/moje/historie"],
  },
} as const satisfies Record<string, RouteDef>;
